(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function initBathModels() {
      document.querySelectorAll('[data-bath-3d-open]').forEach(function (button) {
        if (button.dataset.modelBound) return;
        button.dataset.modelBound = 'true';
        var dialog = document.getElementById(button.getAttribute('aria-controls'));
        if (!dialog) return;
        dialog.querySelector('[data-bath-3d-close]').addEventListener('click', function () { dialog.close(); });
        dialog.addEventListener('click', function (event) { if (event.target === dialog) { var r = dialog.getBoundingClientRect(); if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close(); } });
        button.addEventListener('click', function (event) {
          event.preventDefault(); event.stopPropagation();
          dialog.showModal();
          if (dialog.dataset.modelMounted) return;
          dialog.dataset.modelMounted = 'true';
          var stage = dialog.querySelector('[data-bath-3d-stage]');
          stage.appendChild(dialog.querySelector('template').content.cloneNode(true));
          var viewer = stage.querySelector('model-viewer');
          function showError() { dialog.querySelector('[data-bath-3d-error]').hidden = false; }
          viewer.addEventListener('error', showError);
          if (!customElements.get('model-viewer') && !document.querySelector('script[data-metropole-model-viewer]')) {
            var script = document.createElement('script'); script.type = 'module';
            script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.3.1/model-viewer.min.js';
            script.dataset.metropoleModelViewer = 'true'; script.addEventListener('error', showError); document.head.appendChild(script);
          }
        });
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBathModels); else initBathModels();
    document.addEventListener('shopify:section:load', initBathModels);
  })();

  (function () {
    function init() {
      var gallery = document.querySelector('[data-pdp-gallery]');
      if (!gallery) return;
      var main = gallery.querySelector('[data-pdp-main]');
      var slots = Array.prototype.slice.call(gallery.querySelectorAll('.m-pdp-main-slot'));
      if (!slots.length) return;
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-thumb]'));
      var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-pdp-dot]'));
      var prevBtn = gallery.querySelector('[data-pdp-prev]');
      var nextBtn = gallery.querySelector('[data-pdp-next]');
      var zoomTriggers = gallery.querySelectorAll('[data-pdp-zoom-trigger]');
      var lightbox = document.querySelector('[data-pdp-lightbox]');
      if (lightbox && lightbox.parentNode !== document.body) { document.body.appendChild(lightbox); }

      if (!gallery.querySelector('.m-pdp-main-slot.is-active')) {
        slots[0].classList.add('is-active');
        if (thumbs[0]) thumbs[0].classList.add('is-active');
      }
      var stripMq = window.matchMedia('(max-width: 749px)');
      function curIndex() {
        var a = gallery.querySelector('.m-pdp-main-slot.is-active');
        return a ? (parseInt(a.getAttribute('data-media-index'), 10) || 0) : 0;
      }
      /* Class bookkeeping only — used by the scroll-sync so a user swipe never re-scrolls the rail. */
      function markActive(idx) {
        var len = slots.length; idx = ((idx % len) + len) % len;
        [slots, thumbs, dots].forEach(function (rail) {
          rail.forEach(function (el) {
            el.classList.toggle('is-active', (parseInt(el.getAttribute('data-media-index'), 10) || 0) === idx);
          });
        });
        return idx;
      }
      function setActive(idx) {
        idx = markActive(idx);
        if (stripMq.matches && main) {
          var target = null;
          slots.forEach(function (s) { if ((parseInt(s.getAttribute('data-media-index'), 10) || 0) === idx) target = s; });
          if (target) main.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        }
        return idx;
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { setActive(parseInt(t.getAttribute('data-media-index'), 10) || 0); }); });
      dots.forEach(function (d) { d.addEventListener('click', function () { setActive(parseInt(d.getAttribute('data-media-index'), 10) || 0); }); });
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); setActive(curIndex() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); setActive(curIndex() + 1); });
      if (main && slots.length > 1) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          /* Mobile uses the native scroll-snap rail — the JS swipe would double-advance. */
          if (stripMq.matches) { sx = null; return; }
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) setActive(curIndex() + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }
      /* Keep dots/zoom state in sync with native swipes on the mobile rail.
         IntersectionObserver (not scroll events) — fires for user swipes,
         autoplay scrolls and snap settling alike. */
      if (main && slots.length > 1 && 'IntersectionObserver' in window) {
        var railIO = new IntersectionObserver(function (entries) {
          if (!stripMq.matches) return;
          entries.forEach(function (en) {
            if (en.isIntersecting && en.intersectionRatio >= 0.6) {
              markActive(parseInt(en.target.getAttribute('data-media-index'), 10) || 0);
            }
          });
        }, { root: main, threshold: 0.6 });
        slots.forEach(function (s) { railIO.observe(s); });
      }
      /* Scroll-position fallback for the same sync (belt and braces with the IO above). */
      if (main && slots.length > 1) {
        var syncT = null;
        main.addEventListener('scroll', function () {
          if (!stripMq.matches) return;
          if (syncT) clearTimeout(syncT);
          syncT = setTimeout(function () {
            var w = main.clientWidth; if (!w) return;
            var i = Math.round(main.scrollLeft / w);
            i = Math.max(0, Math.min(i, slots.length - 1));
            markActive(parseInt(slots[i].getAttribute('data-media-index'), 10) || 0);
          }, 90);
        }, { passive: true });
      }
      /* Mobile-only auto-advance; any tap/swipe on the gallery hands control back to the user. */
      if (slots.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var autoMq = stripMq;
        if (window.__mPdpAutoTimer) { clearInterval(window.__mPdpAutoTimer); window.__mPdpAutoTimer = null; }
        var autoStop = function () {
          if (window.__mPdpAutoTimer) { clearInterval(window.__mPdpAutoTimer); window.__mPdpAutoTimer = null; }
        };
        var autoStart = function () {
          autoStop();
          if (!autoMq.matches) return;
          window.__mPdpAutoTimer = setInterval(function () {
            if (!document.hidden) setActive(curIndex() + 1);
          }, 10000);
        };
        gallery.addEventListener('touchstart', autoStop, { passive: true, once: true });
        gallery.addEventListener('click', autoStop, { once: true });
        if (autoMq.addEventListener) autoMq.addEventListener('change', autoStart);
        autoStart();
      }
      if (lightbox) {
        var stage = lightbox.querySelector('[data-pdp-lightbox-stage]');
        function hiRes(img) {
          var ss = img.getAttribute('srcset');
          if (ss) {
            var best = null, bw = 0;
            ss.split(',').forEach(function (p) {
              var t = p.trim().split(/\s+/);
              var w = parseInt((t[1] || '').replace('w', ''), 10) || 0;
              if (w >= bw) { bw = w; best = t[0]; }
            });
            if (best) return best;
          }
          return img.currentSrc || img.src;
        }
        /* The gallery holds two kinds of transparent PNG: white 3D renders of the
           bath, which need the dark backdrop to be visible at all, and the
           technical drawings, which are thin DARK lines on transparency and
           therefore all but disappeared on it — the dimmed page even showed
           through them (Zeyad, 2026-08-11). Nothing in the markup distinguishes
           the two, so the image itself is asked: sample the opaque pixels, and
           give dark artwork a white sheet to sit on. Opaque photos never reach the
           threshold and keep the dark backdrop they are composed for.

           Needs crossOrigin — a canvas that has drawn a cross-origin image is
           tainted and getImageData throws. The Shopify CDN sends
           access-control-allow-origin: *, so the anonymous request is served; if
           it ever is not, the catch leaves the backdrop exactly as it was. */
        function sheetIfDark(big) {
          try {
            var n = 48;
            var canvas = document.createElement('canvas');
            canvas.width = n; canvas.height = n;
            var ctx = canvas.getContext('2d', { willReadFrequently: true });
            ctx.drawImage(big, 0, 0, n, n);
            var data = ctx.getImageData(0, 0, n, n).data;
            var lum = 0, count = 0;
            for (var i = 0; i < data.length; i += 4) {
              if (data[i + 3] < 20) continue;
              lum += data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
              count++;
            }
            if (count && lum / count < 128) {
              big.style.background = '#FFFFFF';
              big.style.padding = '16px';
            }
          } catch (e) { /* tainted canvas or a decode failure: leave it alone */ }
        }
        function renderImg(idx) {
          var slot = slots[idx]; if (!slot) return;
          var img = slot.querySelector('img'); if (!img) return;
          stage.innerHTML = '';
          var big = new Image();
          big.crossOrigin = 'anonymous';
          big.alt = img.alt || '';
          big.style.cssText = 'max-width:100%;max-height:86vh;object-fit:contain;border-radius:0;display:block;box-sizing:border-box;';
          big.addEventListener('load', function () { sheetIfDark(big); });
          big.src = hiRes(img);
          stage.appendChild(big);
        }
        function open(idx) { renderImg(idx); lightbox.hidden = false; lightbox.classList.add('is-open'); lightbox.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
        function close() { lightbox.classList.remove('is-open'); lightbox.hidden = true; lightbox.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; stage.innerHTML = ''; }
        Array.prototype.forEach.call(zoomTriggers, function (z) {
          z.addEventListener('click', function () {
            var i = parseInt(z.getAttribute('data-media-index'), 10) || 0;
            if (z.classList.contains('is-active')) open(i);
          });
        });
        var lbPrev = lightbox.querySelector('[data-pdp-lightbox-prev]');
        var lbNext = lightbox.querySelector('[data-pdp-lightbox-next]');
        var lbClose = lightbox.querySelector('[data-pdp-lightbox-close]');
        if (lbPrev) lbPrev.addEventListener('click', function () { var n = setActive(curIndex() - 1); renderImg(n); });
        if (lbNext) lbNext.addEventListener('click', function () { var n = setActive(curIndex() + 1); renderImg(n); });
        if (lbClose) lbClose.addEventListener('click', close);
        lightbox.addEventListener('click', function (e) {
          if (e.target.tagName === 'IMG') return;
          if (e.target.closest('[data-pdp-lightbox-close],[data-pdp-lightbox-prev],[data-pdp-lightbox-next]')) return;
          close();
        });
        document.addEventListener('keydown', function (e) {
          if (!lightbox.classList.contains('is-open')) return;
          if (e.key === 'Escape') close();
          else if (e.key === 'ArrowLeft' && lbPrev) lbPrev.click();
          else if (e.key === 'ArrowRight' && lbNext) lbNext.click();
        });
      }
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["accelerated-checkout"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mBuyNowBound) return;
    window.__mBuyNowBound = true;
    /* Back-navigation (bfcache) restores the page with the button still disabled — re-arm it. */
    window.addEventListener('pageshow', function () {
      document.querySelectorAll('[data-metropole-buy-now][disabled]').forEach(function (b) {
        b.removeAttribute('disabled');
      });
    });
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-metropole-buy-now]');
      if (!btn || btn.hasAttribute('disabled')) return;
      e.preventDefault();
      var form = btn.closest('form');
      var idInput = form && form.querySelector('[name="id"]');
      if (!idInput || !idInput.value) return;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      /* Line-item properties ride along exactly as "Añadir al carrito" sends them:
         the pre-order note (blocks/buy-buttons.liquid) and the scheduled-delivery
         date (blocks/metropole-delivery-schedule.liquid). form.elements, not
         querySelectorAll, because the schedule inputs live outside the <form> and
         join it through form="…". Without this, buy-now orders reached checkout
         with neither — the customer never saw they had bought a pre-order. */
      var properties = {};
      Array.prototype.forEach.call(form.elements, function (el) {
        var m = el.name && el.name.match(/^properties\[(.+)\]$/);
        if (!m || el.disabled || el.value === '') return;
        if ((el.type === 'checkbox' || el.type === 'radio') && !el.checked) return;
        properties[m[1]] = el.value;
      });
      var item = { id: parseInt(idInput.value, 10), quantity: qty };
      if (Object.keys(properties).length) item.properties = properties;
      btn.setAttribute('disabled', 'disabled');
      fetch(btn.getAttribute('data-cart-add-url') || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(item)
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.removeAttribute('disabled');
          window.location.href = '/cart';
        });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropole-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    // One shared deadline, rendered server-side as an epoch. The element starts
    // hidden and is only revealed once the client clock agrees there is time left,
    // so a stale cached page can never show a countdown that has already run out.
    function tick(el) {
      var endsAt = parseInt(el.getAttribute('data-ends-at'), 10);
      if (!endsAt) return false;
      var remaining = endsAt * 1000 - Date.now();
      // Date.now() is the visitor's clock, which we do not control. A device whose date is
      // years behind turns a three-week campaign into "2222d" — worse than showing nothing,
      // because a nonsense deadline reads as a broken (or fake) offer. No METROPOLE campaign
      // runs longer than a season, so anything past MAX_MS means the clock, not the offer.
      var MAX_MS = 400 * 24 * 60 * 60 * 1000;
      if (remaining <= 0 || remaining > MAX_MS || !isFinite(remaining)) {
        el.hidden = true;
        return false;
      }
      var minutes = Math.floor(remaining / 60000);
      var days = Math.floor(minutes / 1440);
      var hours = Math.floor((minutes % 1440) / 60);
      var mins = minutes % 60;
      var d = el.querySelector('[data-cd-days]');
      var h = el.querySelector('[data-cd-hours]');
      var m = el.querySelector('[data-cd-minutes]');
      if (d) d.textContent = days;
      if (h) h.textContent = hours;
      if (m) m.textContent = mins;
      el.hidden = false;
      return true;
    }

    function init() {
      if (window.__mCountdownTimer) {
        clearInterval(window.__mCountdownTimer);
        window.__mCountdownTimer = null;
      }
      var els = Array.prototype.slice.call(document.querySelectorAll('[data-m-countdown]'));
      if (!els.length) return;
      var run = function () {
        var alive = false;
        els.forEach(function (el) {
          if (tick(el)) alive = true;
        });
        if (!alive && window.__mCountdownTimer) {
          clearInterval(window.__mCountdownTimer);
          window.__mCountdownTimer = null;
        }
      };
      run();
      window.__mCountdownTimer = setInterval(run, 30000);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropole-delivery-schedule"] && !Shopify.designMode) return;
  try {
    // Recompute the selectable range against the visitor's clock, then arm the
  // field only while the panel is open.
  (() => {
    const iso = (d) => {
      // Local calendar date, not UTC — toISOString() would roll the date back
      // an hour before midnight in Madrid and offer a day that is already out
      // of range by the browser's own min/max check.
      const m = String(d.getMonth() + 1).padStart(2, '0');
      const day = String(d.getDate()).padStart(2, '0');
      return `${d.getFullYear()}-${m}-${day}`;
    };

    const setup = (root) => {
      const check = root.querySelector('[data-m-sched-check]');
      const panel = root.querySelector('[data-m-sched-panel]');
      const input = root.querySelector('[data-m-sched-input]');
      if (!check || !panel || !input) return;

      const lead = parseInt(root.dataset.leadDays || '14', 10);
      const max = parseInt(root.dataset.maxDays || '45', 10);
      const from = new Date();
      from.setDate(from.getDate() + lead);
      const to = new Date();
      to.setDate(to.getDate() + max);
      input.min = iso(from);
      input.max = iso(to);

      check.addEventListener('change', () => {
        panel.hidden = !check.checked;
        input.disabled = !check.checked;
        if (!check.checked) input.value = '';
      });
    };

    const init = () => document.querySelectorAll('[data-m-sched]').forEach(setup);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
    // The product section is re-rendered wholesale on a variant change, which
    // replaces these nodes and drops their listeners.
    document.addEventListener('variant:update', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropole-delivery"] && !Shopify.designMode) return;
  try {
    (function () {
    // Recompute from the visitor's own clock. Same rule as the Liquid above: skip
    // Sat/Sun. The two day counts come from data-min/data-max so the market split
    // is decided server-side ONCE and this cannot drift from it. Guards against a cached page
    // quoting a window that has already started to expire.
    function label(date, months) {
      return date.getDate() + ' ' + months[date.getMonth()];
    }

    function businessDayFromToday(count) {
      var d = new Date();
      var added = 0;
      while (added < count) {
        d.setDate(d.getDate() + 1);
        var wd = d.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d;
    }

    function render() {
      document.querySelectorAll('[data-m-delivery]').forEach(function (el) {
        var months = (el.getAttribute('data-months') || '').split(',');
        if (months.length !== 12) return;
        var from = el.querySelector('[data-m-delivery-from]');
        var to = el.querySelector('[data-m-delivery-to]');
        var lo = parseInt(el.getAttribute('data-min'), 10);
        var hi = parseInt(el.getAttribute('data-max'), 10);
        if (!lo || !hi) return;
        if (from) from.textContent = label(businessDayFromToday(lo), months);
        if (to) to.textContent = label(businessDayFromToday(hi), months);
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
    else render();
    document.addEventListener('shopify:section:load', render);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropole-klarna"] && !Shopify.designMode) return;
  try {
    // Keep the instalment figure in step with the variant price.
  //
  // The theme re-renders the whole product section on a variant change and
  // hands the fresh markup to listeners on `variant:update` as a parsed
  // document (assets/events.js). Pulling this block's replacement out of that
  // document is the same mechanism assets/product-price.js uses for the price
  // itself, so the two can never disagree. Written as a plain listener rather
  // than a custom element so it needs no import-map entry.
  document.addEventListener('variant:update', (event) => {
    const html = event.detail?.data?.html;
    if (!html) return;

    for (const el of document.querySelectorAll('[data-m-klarna]')) {
      const blockId = el.getAttribute('data-block-id');
      const next = html.querySelector(`[data-m-klarna][data-block-id="${blockId}"]`);
      // A variant below the Klarna minimum renders no block at all, so the
      // absence of a replacement means "hide", not "leave the old figure up".
      el.hidden = !next;
      if (next) el.innerHTML = next.innerHTML;
    }
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["metropole-warranty"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('metropole-warranty')) return;

    const STORE_PREFIX = 'metropole:warranty:';

    // Safari in private mode throws on any storage access rather than returning
    // null, so every read and write is wrapped. Same treatment as
    // snippets/metropole-click-attribution.liquid.
    const readStore = (key) => {
      try {
        return window.sessionStorage.getItem(STORE_PREFIX + key);
      } catch (e) {
        return null;
      }
    };
    const writeStore = (key, value) => {
      try {
        if (value) window.sessionStorage.setItem(STORE_PREFIX + key, value);
        else window.sessionStorage.removeItem(STORE_PREFIX + key);
      } catch (e) {
        /* no persistence available; the in-memory field still holds for this page */
      }
    };

    class MetropoleWarranty extends HTMLElement {
      #variantId = null;

      connectedCallback() {
        const stored = readStore(this.dataset.productId || '');
        if (stored && this.#radios().some((r) => r.value === stored)) this.#variantId = stored;

        this.#apply();
        this.addEventListener('change', this.#onChange);

        // Re-assert rather than re-read the DOM: a morph that did slip through
        // would have reset the radios, and the field is the source of truth.
        document.addEventListener('variant:update', this.#onVariantUpdate);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.#onChange);
        document.removeEventListener('variant:update', this.#onVariantUpdate);
      }

      #radios() {
        return Array.from(this.querySelectorAll('.m-warr-radio'));
      }

      #onChange = (event) => {
        const target = event.target;
        if (!target || !target.classList || !target.classList.contains('m-warr-radio')) return;
        this.#variantId = target.value || null;
        writeStore(this.dataset.productId || '', this.#variantId);
        // The browser has already moved the radio, so only the collapsed
        // summary needs updating — #apply() would redundantly re-set the
        // radios. Without this the summary keeps showing the tier the page
        // loaded with, which is worst exactly when the panel is closed.
        this.#syncSummary();
        this.clearError();
      };

      #onVariantUpdate = () => this.#apply();

      #apply() {
        const wanted = this.#variantId || '';
        for (const radio of this.#radios()) radio.checked = radio.value === wanted;
        this.#syncSummary();
      }

      // Keep the collapsed row honest about what is actually selected — a buyer
      // who picks a tier, collapses the panel and scrolls to the button would
      // otherwise have no way to see it without reopening.
      #syncSummary() {
        const out = this.querySelector('[data-m-warr-value]');
        if (!out) return;
        const checked = this.#radios().find((r) => r.checked);
        const opt = checked && checked.closest('.m-warr-opt');
        if (!opt) return;
        const title = opt.querySelector('.m-warr-title');
        const price = opt.querySelector('.m-warr-price');
        out.textContent = title
          ? (price ? `${title.textContent.trim()} · ${price.textContent.trim()}` : title.textContent.trim())
          : out.textContent;
      }

      /** True when a paid tier is chosen. The free tier carries value="". */
      hasSelection() {
        return this.#variantId != null && this.#variantId !== '';
      }

      /**
       * The add-on's line for a /cart/add.js items[] payload, or null on the free
       * tier. `Cubre` is deliberately a fixed Spanish string and NOT localised —
       * one key, greppable in admin whatever locale the buyer browsed in, exactly
       * as `Entrega programada` is next door. The underscore-prefixed keys are
       * hidden from the buyer by snippets/cart-products.liquid.
       */
      getAddOnItem(context) {
        if (!this.hasSelection()) return null;
        const quantity = Number(context && context.quantity) || 1;
        return {
          id: Number(this.#variantId),
          quantity,
          properties: {
            _m_pair: context.pair,
            _m_role: 'child',
            _m_parent_variant: String(context.variantId || ''),
            Cubre: this.dataset.productTitle || document.title,
          },
        };
      }

      showError() {
        const el = this.querySelector('[data-m-warr-error]');
        if (el) el.hidden = false;
      }

      clearError() {
        const el = this.querySelector('[data-m-warr-error]');
        if (el) el.hidden = true;
      }
    }

    customElements.define('metropole-warranty', MetropoleWarranty);
  })();
  } catch(e) { console.error(e); }
})();

})();
